const isDebug = process.env.NODE_ENV !== 'production';

export function debugLog(...args: unknown[]): void {
  if (isDebug) console.log(...args);
}
